import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function SystemUpdates(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#BBEBFA"/>
      <path d="M16 10V6L11 11L16 16V12C19.31 12 22 14.69 22 18C22 21.31 19.31 24 16 24C12.69 24 10 21.31 10 18H8C8 22.42 11.58 26 16 26C20.42 26 24 22.42 24 18C24 13.58 20.42 10 16 10Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
